// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RewardCategory from "../../domain/types/RewardCategory.bs.js";
import * as RewardMilestone from "../../domain/types/RewardMilestone.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as RescriptReactRouter from "../../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";

function shouldDisplayDefaultAward(awardedAt) {
  return DateTime$Catalyst.isBefore(awardedAt, DateTime$Catalyst.fromString(undefined, DateTime$Catalyst.calculateEndDate(DateTime$Catalyst.getYesterday(undefined), "DD/MM/YYYY")));
}

function getValidAward(award_to_display) {
  if (typeof award_to_display === "number") {
    return /* DefaultAward */0;
  }
  switch (award_to_display.TAG | 0) {
    case /* NoAward */3 :
        if ((DateTime$Catalyst.toTimeStamp(award_to_display._0.awardedAt) + 28800 | 0) < DateTime$Catalyst.toTimeStamp(new Date())) {
          return /* DefaultAward */0;
        } else {
          return award_to_display;
        }
    case /* Coupon */8 :
        if (shouldDisplayDefaultAward(award_to_display._0.awardedAt)) {
          return /* DefaultAward */0;
        } else {
          return award_to_display;
        }
    default:
      if (shouldDisplayDefaultAward(award_to_display._0.awardedAt)) {
        return /* DefaultAward */0;
      } else {
        return award_to_display;
      }
  }
}

function isAwardModalVisible(param) {
  return RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined).hash === "awards";
}

function isRewardModalVisible(param) {
  return RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined).hash === "rewards";
}

function getAward(milestoneDetails, milestone, checkDisplayValidity) {
  if (milestone === 0) {
    return /* DefaultAward */0;
  }
  var milestone_sel = List.find((function (claimed) {
          return milestone === claimed.milestone;
        }), milestoneDetails.claimedMilestones);
  if (checkDisplayValidity) {
    return getValidAward(milestone_sel.award);
  } else {
    return milestone_sel.award;
  }
}

function getCategoryFromUrl(url_params) {
  var category = Js_dict.get(url_params, "category");
  if (category !== undefined) {
    return RewardCategory.fromString(category);
  }
  
}

function getDateFromUrl(url_params) {
  var date = Js_dict.get(url_params, "date");
  if (date !== undefined) {
    return Caml_option.some(DateTime$Catalyst.fromString("YYYY-MM-DD", date));
  }
  
}

function getRewardSelectedCategory(param) {
  var url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
  var match = url.hash;
  if (match === "rewards") {
    return getCategoryFromUrl(UrlUtils$Catalyst.getURLParams(url.search));
  }
  
}

function getRewardSelectedDate(param) {
  var url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
  var match = url.hash;
  if (match === "rewards") {
    return getDateFromUrl(UrlUtils$Catalyst.getURLParams(url.search));
  }
  
}

function getMilestone(param) {
  var url = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined);
  var match = url.hash;
  if (match !== "awards") {
    return /* Star */0;
  }
  var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
  var milestone = Js_dict.get(urlParams, "milestone");
  if (milestone !== undefined) {
    return RewardMilestone.fromUrlString(milestone);
  } else {
    return ErrorUtils$Catalyst.raiseError("RnrModalsHelper.re", "Invalid Milestone", "");
  }
}

export {
  shouldDisplayDefaultAward ,
  getValidAward ,
  isAwardModalVisible ,
  isRewardModalVisible ,
  getAward ,
  getCategoryFromUrl ,
  getDateFromUrl ,
  getRewardSelectedCategory ,
  getRewardSelectedDate ,
  getMilestone ,
  
}
/* DateTime-Catalyst Not a pure module */
